exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small[data-v-5a54e73c]{max-width:600px;margin:150px auto}", ""]);

// exports
